import React, { createContext, useContext, useState, useEffect } from 'react';

// إنشاء سياق السمة
const ThemeContext = createContext();

// مزود سياق السمة
export const ThemeProvider = ({ children }) => {
  // استخدام الحالة لتخزين السمة الحالية
  const [theme, setTheme] = useState('light'); // الافتراضي هو السمة الفاتحة

  // تحميل السمة المحفوظة من التخزين المحلي عند بدء التشغيل
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setTheme(savedTheme);
    }
  }, []);

  // حفظ السمة في التخزين المحلي عند تغييرها
  useEffect(() => {
    localStorage.setItem('theme', theme);
    // تطبيق السمة على عنصر الجسم
    document.body.className = theme;
  }, [theme]);

  // تبديل السمة بين الفاتحة والداكنة
  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // تغيير السمة إلى سمة محددة
  const changeTheme = (newTheme) => {
    if (newTheme === 'light' || newTheme === 'dark') {
      setTheme(newTheme);
    }
  };

  // القيمة التي سيتم توفيرها للمكونات
  const value = {
    theme,
    toggleTheme,
    changeTheme,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

// هوك مخصص لاستخدام سياق السمة
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('يجب استخدام useTheme داخل ThemeProvider');
  }
  return context;
};